import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { HotelAmenityType } from '@libs/trip-planner-interfaces';
import type { AppSvgIconType } from '@libs/ui';

export interface HotelAmenityData {
  icon: AppSvgIconType;
  value: string;
}

const { t } = i18n.global;

export function getHotelAmenitiesConfig(): Record<
  HotelAmenityType,
  HotelAmenityData
> {
  return {
    [HotelAmenityType.IsAdultsOnly]: {
      icon: 'adultsOnly',
      value: t('filter.amenities.adults_only'),
    },
    [HotelAmenityType.HasAirConditioning]: {
      icon: 'airConditioning',
      value: t('filter.amenities.air_conditioning'),
    },
    [HotelAmenityType.HasAllInclusive]: {
      icon: 'allInclusive',
      value: t('filter.amenities.all_inclusive'),
    },
    [HotelAmenityType.HasBalcony]: {
      icon: 'balcony',
      value: t('filter.amenities.balcony'),
    },
    [HotelAmenityType.HasBalconyOrTerrace]: {
      icon: 'balcony',
      value: t('filter.amenities.balcony_or_terrace'),
    },
    [HotelAmenityType.HasBar]: {
      icon: 'bar',
      value: t('filter.amenities.bar'),
    },
    [HotelAmenityType.HasBathtubOrShower]: {
      icon: 'shower',
      value: t('filter.amenities.bathtub_or_shower'),
    },
    [HotelAmenityType.HasBoutique]: {
      icon: 'boutique',
      value: t('filter.amenities.boutique'),
    },
    [HotelAmenityType.HasCableOrSatteliteTelevision]: {
      icon: 'tv',
      value: t('filter.amenities.cable_or_satellite_television'),
    },
    [HotelAmenityType.HasCarpet]: {
      icon: 'carpet',
      value: t('filter.amenities.carpet'),
    },
    [HotelAmenityType.HasCastleOrMansion]: {
      icon: 'castle',
      value: t('filter.amenities.castle_or_mansion'),
    },
    [HotelAmenityType.HasCeilingFan]: {
      icon: 'ceilingFan',
      value: t('filter.amenities.ceiling_fan'),
    },
    [HotelAmenityType.HasChildBeds]: {
      icon: 'childBeds',
      value: t('filter.amenities.child_beds'),
    },
    [HotelAmenityType.HasChildChairs]: {
      icon: 'childChairs',
      value: t('filter.amenities.child_chairs'),
    },
    [HotelAmenityType.HasChildrensPool]: {
      icon: 'pool',
      value: t('filter.amenities.childrens_pool'),
    },
    [HotelAmenityType.HasCoffeeMaker]: {
      icon: 'coffeeMaker',
      value: t('filter.amenities.coffee_maker'),
    },
    [HotelAmenityType.HasConferenceRoom]: {
      icon: 'conferenceRoom',
      value: t('filter.amenities.conference_room'),
    },
    [HotelAmenityType.HasDesk]: {
      icon: 'desk',
      value: t('filter.amenities.desk'),
    },
    [HotelAmenityType.HasDishWasher]: {
      icon: 'dishwasher',
      value: t('filter.amenities.dish_washer'),
    },
    [HotelAmenityType.HasDryer]: {
      icon: 'hairDryer',
      value: t('filter.amenities.dryer'),
    },
    [HotelAmenityType.HasElectricCarCharger]: {
      icon: 'electricCarCharger',
      value: t('filter.amenities.electric_car_charger'),
    },
    [HotelAmenityType.HasEngineHeater]: {
      icon: 'engineHeater',
      value: t('filter.amenities.engine_heater'),
    },
    [HotelAmenityType.HasFirePlace]: {
      icon: 'fireplace',
      value: t('filter.amenities.fire_place'),
    },
    [HotelAmenityType.HasFreezer]: {
      icon: 'freezer',
      value: t('filter.amenities.freezer'),
    },
    [HotelAmenityType.HasGarage]: {
      icon: 'garage',
      value: t('filter.amenities.garage'),
    },
    [HotelAmenityType.HasGarden]: {
      icon: 'garden',
      value: t('filter.amenities.garden'),
    },
    [HotelAmenityType.HasGym]: {
      icon: 'gym',
      value: t('filter.amenities.gym'),
    },
    [HotelAmenityType.HasHairDryer]: {
      icon: 'hairDryer',
      value: t('filter.amenities.hair_dryer'),
    },
    [HotelAmenityType.HasInternet]: {
      icon: 'internet',
      value: t('filter.amenities.internet'),
    },
    [HotelAmenityType.HasIron]: {
      icon: 'iron',
      value: t('filter.amenities.iron'),
    },
    [HotelAmenityType.HasIroningBoard]: {
      icon: 'iron',
      value: t('filter.amenities.ironing_board'),
    },
    [HotelAmenityType.HasJacuzzi]: {
      icon: 'jacuzzi',
      value: t('filter.amenities.jacuzzi'),
    },
    [HotelAmenityType.HasKettle]: {
      icon: 'kettle',
      value: t('filter.amenities.kettle'),
    },
    [HotelAmenityType.HasLakeView]: {
      icon: 'lakeView',
      value: t('filter.amenities.lake_view'),
    },
    [HotelAmenityType.HasMicroWaveOven]: {
      icon: 'microwave',
      value: t('filter.amenities.microwave_oven'),
    },
    [HotelAmenityType.HasMiniBar]: {
      icon: 'miniBar',
      value: t('filter.amenities.mini_bar'),
    },
    [HotelAmenityType.HasMountainView]: {
      icon: 'mountainView',
      value: t('filter.amenities.mountain_view'),
    },
    [HotelAmenityType.HasOven]: {
      icon: 'oven',
      value: t('filter.amenities.oven'),
    },
    [HotelAmenityType.HasParking]: {
      icon: 'parking',
      value: t('filter.amenities.parking'),
    },
    [HotelAmenityType.HasPool]: {
      icon: 'pool',
      value: t('filter.amenities.pool'),
    },
    [HotelAmenityType.HasPorch]: {
      icon: 'terrace',
      value: t('filter.amenities.porch'),
    },
    [HotelAmenityType.HasSafetyBox]: {
      icon: 'safetyBox',
      value: t('filter.amenities.safety_box'),
    },
    [HotelAmenityType.HasSauna]: {
      icon: 'sauna',
      value: t('filter.amenities.sauna'),
    },
    [HotelAmenityType.HasSeaView]: {
      icon: 'seaView',
      value: t('filter.amenities.sea_view'),
    },
    [HotelAmenityType.HasShower]: {
      icon: 'shower',
      value: t('filter.amenities.shower'),
    },
    [HotelAmenityType.HasSkiInSkiOut]: {
      icon: 'ski',
      value: t('filter.amenities.ski_in_ski_out'),
    },
    [HotelAmenityType.HasSpa]: {
      icon: 'spa',
      value: t('filter.amenities.spa'),
    },
    [HotelAmenityType.HasSunbeds]: {
      icon: 'sunbeds',
      value: t('filter.amenities.sunbeds'),
    },
    [HotelAmenityType.HasTelephone]: {
      icon: 'phone',
      value: t('filter.amenities.telephone'),
    },
    [HotelAmenityType.HasTelevision]: {
      icon: 'tv',
      value: t('filter.amenities.television'),
    },
    [HotelAmenityType.HasTennis]: {
      icon: 'tennis',
      value: t('filter.amenities.tennis'),
    },
    [HotelAmenityType.HasTerrace]: {
      icon: 'terrace',
      value: t('filter.amenities.terrace'),
    },
    [HotelAmenityType.HasToaster]: {
      icon: 'toaster',
      value: t('filter.amenities.toaster'),
    },
    [HotelAmenityType.HasVineyard]: {
      icon: 'vineyard',
      value: t('filter.amenities.vineyard'),
    },
    [HotelAmenityType.HasWashingMachine]: {
      icon: 'washingMachine',
      value: t('filter.amenities.washing_machine'),
    },
    [HotelAmenityType.IsBusinessProperty]: {
      icon: 'case',
      value: t('filter.amenities.business_property'),
    },
    [HotelAmenityType.IsFamilyProperty]: {
      icon: 'family',
      value: t('filter.amenities.family_property'),
    },
    [HotelAmenityType.IsGreenSustainableProperty]: {
      icon: 'sustainable',
      value: t('filter.amenities.green_sustainable_property'),
    },
    [HotelAmenityType.IsSmokingAllowed]: {
      icon: 'smoking',
      value: t('filter.amenities.smoking_allowed'),
    },
    [HotelAmenityType.IsSmokingDisallowed]: {
      icon: 'noSmoking',
      value: t('filter.amenities.smoking_disallowed'),
    },
    [HotelAmenityType.IsSunnySide]: {
      icon: 'sun',
      value: t('filter.amenities.sunny_side'),
    },
    [HotelAmenityType.PetsAreAllowed]: {
      icon: 'pets',
      value: t('filter.amenities.pets_allowed'),
    },
    [HotelAmenityType.PetsAreNotAllowed]: {
      icon: 'noPets',
      value: t('filter.amenities.pets_not_allowed'),
    },
  };
}
